import { array, shape, string } from "prop-types";

export const formDataPropType = shape({
  departmentAgencies: array,
  naicsCodes: string,
  classificationCodes: string,
  contractTypes: array,
  setAsides: array,
  subTiers: array,
  offices: array,
  placeOfPerformance: string,
  officeLocation: string,
});
